import dayjs from 'dayjs'
import { useSelector } from 'react-redux'
import Table from 'src/features/base/components/Table'
import { selectFulfillmentCenters } from 'src/features/selector'
import { selectProductReserves, selectProductTabFilters } from 'src/features/stock-management/StockManagementSeletor'
import { FulfillmentCenter } from 'src/features/types'
import { NumberFmt } from 'src/utils'
import columns from './Table.columns'

export default () => {
  const reserves = useSelector(selectProductReserves)
  const currentFC = useSelector(selectProductTabFilters)
  const fulfillmentCenterList = useSelector(selectFulfillmentCenters)

  const getFulfillmentCenter = (
    currentFCId?: number,
    FCList?: FulfillmentCenter[],
  ) => FCList?.find((fc) => fc.id === currentFCId)

  const fullFillmentCenter = getFulfillmentCenter(
    Number(currentFC.fulfillmentCenterId),
    fulfillmentCenterList,
  )

  const reserveRow = reserves.items.map((reserveItem) => ({
    ...reserveItem,
    quantity: NumberFmt({ value: reserveItem.quantity, sufix: '' }),
    deliveryDate: reserveItem.deliveryDate ? dayjs(reserveItem.deliveryDate).format('DD/MM/YYYY') : '-',
    reserveDate: dayjs(reserveItem.reserveDate).format('DD/MM/YYYY HH:mm:ss'),
    fc: fullFillmentCenter?.name,
  }))

  return (
    <Table data-testid='reserves-table' data={reserveRow} columns={columns} />
  )
}
